import { linkTo } from "querypieces";

export default `
  iconHeadingSet {
    ...on iconHeadingSetItem_Entry {
      id
      icon {
        title
        url
      }
      heading,
      ${linkTo}
    }
  }
`;
